import {action, autorun, observable} from 'mobx'
import {notification} from 'antd'

import {getLoadErrorMessage} from './consts/errorMessages'

export class Single {
  @observable data = {}
  @observable algo = {}
  @observable loading = false

  constructor(rootStore, api) {
    this.root = rootStore
    this.api = api
  }

  showErrorMessage = autorun(() => {
    if (this.data.error_message) {
      notification['error']({
        message: 'Your backtest failed with reason:',
        description: this.data.error_message
      })
    }
  })

  showInterruptedMessage = autorun(() => {
    if (this.data.is_interrupted_by_user) {
      notification['warning']({
        message: 'Backtest was interrupted by user'
      })
    }
  })

  @action change = (name, value) => {
    this.data[name] = value
  }

  @action load = async (id = this.data.id, ticker) => {
    this.loading = true
    this.data = {}
    this.algo = {}

    let url = `sys/backtests/${id}`
    if (ticker) {
      url += `?ticker=${ticker}`
    }

    try {
      const {algo, ...data} = await this.api.request(url, 'get')
      this.algo = algo
      this.data = {...data}
      this.loadAdditionalData()
    } catch (e) {
      if (e.status_code === 404) {
        this.root.redirectTo({pathname: '/not-found'})
        return
      }
      notification['error']({
        description: getLoadErrorMessage(e.code)
      })
      this.data = {id}
      this.algo = {}
    } finally {
      this.loading = false
    }
  }

  // find a way to move loadAdditionalData to parent store (backtest/index.js)
  @action loadAdditionalData = () => {
    const {status, is_interrupted_by_user, id} = this.data
    if (status === 'done' && !is_interrupted_by_user && id) {
      this.root.backtest.messages.load(id)
      this.root.backtest.fetchMetrics(id)
      this.root.backtest.tables.fetchMetrics(id)
      this.root.backtest.tables.fetchTransactions(id)
    }
  }
}
